import { IFragmentItem } from '@/router/IFragmentItem';

export class Area implements IFragmentItem {
	public get value(): string {
		return this.id;
	}

	public get pathAlternatives(): readonly string[] {
		return [];
	}

	public constructor(public readonly id: string, public readonly path: string) {}
}
